// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1qTRE","itemTitle":"ClientEmergencyInfo_itemTitle__2r1ww","itemText":"ClientEmergencyInfo_itemText__NqYFL"};